module.exports = __webpack_public_path__ + "static/media/book.6478517f.svg";